import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Dialog } from '@angular/cdk/dialog';
import * as moment from 'moment/moment';
import { getError, Unsubscriber } from '@shared';
import { financialMonitoringModalConfig } from '@services';
import { BirthDateErrors, EEnterBirthDateFormFields } from './enter-birth-date.constants';
import { FinancialMonitoringInfoComponent } from '../financial-monitoring-info/financial-monitoring-info.component';

@Component({
  selector: 'app-enter-birth-date',
  templateUrl: './enter-birth-date.component.html',
  styleUrls: ['./enter-birth-date.component.scss'],
})
export class EnterBirthDateComponent extends Unsubscriber implements OnInit {
  protected readonly getError = getError;
  protected readonly errors = BirthDateErrors;

  maxDate = moment().toDate();
  dateValue: Date = null;
  birthDateGroup: FormGroup;

  get birthDateControl(): FormControl {
    return this.birthDateGroup.get(EEnterBirthDateFormFields.BIRTH_DATE) as FormControl;
  }

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<EnterBirthDateComponent>,
    private fb: FormBuilder,
    private dateAdapter: DateAdapter<NativeDateAdapter>,
  ) {
    super();
    dateAdapter.setLocale('uk-UA');
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.birthDateGroup = this.fb.group({
      [EEnterBirthDateFormFields.BIRTH_DATE]: [null, Validators.required],
    });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  onDateChange($event): void {
    this.dateValue = new Date($event);
  }

  moreInfo(): void {
    this.dialog.open(FinancialMonitoringInfoComponent, financialMonitoringModalConfig);
  }

  save(): void {
    if (this.birthDateGroup.valid) {
      this.dialogRef.close(moment(this.dateValue).format('YYYY.MM.DD'));
    } else {
      this.birthDateControl.markAsTouched();
    }
  }
}
